import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { productTypeFilterConfig } from '../../../configs/product-type-filter-config';

export const ProductTypeFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Type'
      config={productTypeFilterConfig}
    />
  );
};
